import { render } from "./ProductTypesV2.vue?vue&type=template&id=5301f4fa&scoped=true"
import script from "./ProductTypesV2.vue?vue&type=script&lang=js"
export * from "./ProductTypesV2.vue?vue&type=script&lang=js"

import "./ProductTypesV2.vue?vue&type=style&index=0&id=5301f4fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5301f4fa"]])

export default __exports__